import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import style from './search-result-list.module.less';
import ModalFooterWithAction from '../../../components/modal-footer-actions';
import { messages } from '../messages';

/**
 * @typedef {import('../types').OrderSearchResult} OrderSearchResult
 */

/**
 * @param {object} props
 * @param {OrderSearchResult[]} props.items
 * @param {string} props.keyField
 * @param {string|JSX.Element} props.header
 * @param {string|JSX.Element} props.bodyText
 * @param {(isCancel: boolean) => void} props.onClose
 * @param {(item: OrderSearchResult) => void} props.onItemClick
 * @param {(item: OrderSearchResult, displayIndex: number) => JSX.Element} props.renderItem
 * @returns {JSX.Element}
 */
export const SearchResultList = ({ items, onItemClick, onClose, header, bodyText, keyField, renderItem }) => {
  const [selectedItem, setSelectedItem] = useState(items[0]);
  const onContinue = useCallback(() => {
    onItemClick(selectedItem);
  }, [onItemClick, selectedItem]);
  const onSelectItem = useCallback((item) => {
    setSelectedItem(item);
  }, []);
  return (
    items.length && (
      <Modal className={style['item-result-modal']}>
        <ModalHeader className={style.header} closeModal={onClose}>
          {header}
        </ModalHeader>
        <ModalBody>
          <div className={style.body}>
            <div className={style['body-text']}>{bodyText}</div>
            <div className={style['item-list']}>
              {items.map((item, index) => {
                const displayIndex = index + 1;
                return (
                  <div
                    key={item[keyField]}
                    className={classnames(style.item, {
                      [style.selected]: selectedItem === item,
                    })}
                    onClick={() => onSelectItem(item)}
                  >
                    <RadioCheckListItem
                      key={item[keyField]}
                      className={style['radio-button']}
                      isChecked={selectedItem === item}
                      onChecked={() => onSelectItem(item)}
                    />
                    {renderItem(item, displayIndex)}
                  </div>
                );
              })}
            </div>
          </div>
        </ModalBody>
        <ModalFooterWithAction
          actionMessage={<FormattedMessage {...messages.continue} />}
          actionTheme='primary'
          cancelMessage={<FormattedMessage {...messages.cancel} />}
          footerClassName={style.footer}
          onAction={onContinue}
          onCancel={onClose}
        />
      </Modal>
    )
  );
};
